(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-xmas26-blanket-master"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mm-blanket-master')){customElements.define('mm-blanket-master',class extends HTMLElement{
  connectedCallback(){
    if(this.dataset.initialized)return;this.dataset.initialized='true';
    const main=this.querySelector('.mm-main-image');
    this.querySelectorAll('[data-photo]').forEach(button=>button.addEventListener('click',()=>{
      this.querySelectorAll('[data-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      main.src=button.dataset.photo;main.removeAttribute('srcset');main.alt=button.dataset.label;
    }));
    const parts=this.dataset.orderDate.split('-').map(Number),today=Date.UTC(parts[0],parts[1]-1,parts[2]);
    const dateFormat=new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',timeZone:'UTC'});
    const dateAt=offset=>new Date(today+offset*86400000),formatDate=value=>dateFormat.format(value);
    const arrivalWindow=[7,10].map(offset=>formatDate(dateAt(offset))).join(' - ');
    const trigger=this.querySelector('[data-delivery-window]'),desktopPanel=this.querySelector('.mm-timeline-desktop'),mobilePanel=this.querySelector('.mm-timeline-mobile');
    trigger.textContent=arrivalWindow;
    this.querySelectorAll('[data-order-day]').forEach(node=>{node.textContent=formatDate(dateAt(0));});
    this.querySelectorAll('[data-ship-window]').forEach(node=>{node.textContent=formatDate(dateAt(2));});
    this.querySelectorAll('[data-arrival-window]').forEach(node=>{node.textContent=arrivalWindow;});
    const timelineEvents=new AbortController();this.timelineEvents=timelineEvents;
    const desktopMode=()=>matchMedia('(min-width:750px) and (hover:hover)').matches;
    let pinned=false,closeTimer;
    const positionPanel=()=>{const anchor=trigger.getBoundingClientRect(),width=desktopPanel.offsetWidth,height=desktopPanel.offsetHeight,left=Math.max(12,Math.min(innerWidth-width-12,anchor.left+anchor.width/2-width/2)),above=anchor.bottom+height+12>innerHeight&&anchor.top>height+12;desktopPanel.style.left=left+'px';desktopPanel.style.top=(above?anchor.top-height-10:anchor.bottom+10)+'px';desktopPanel.style.setProperty('--mm-tip',Math.max(16,Math.min(width-16,anchor.left+anchor.width/2-left))+'px');desktopPanel.classList.toggle('mm-timeline-above',above);};
    const closeTimeline=(restore=false)=>{clearTimeout(closeTimer);if(desktopPanel.matches(':popover-open'))desktopPanel.hidePopover();if(mobilePanel.open)mobilePanel.close();trigger.setAttribute('aria-expanded','false');pinned=false;if(restore)trigger.focus({preventScroll:true});};
    const openTimeline=()=>{clearTimeout(closeTimer);if(desktopMode()){if(mobilePanel.open)mobilePanel.close();if(!desktopPanel.matches(':popover-open'))desktopPanel.showPopover({source:trigger});trigger.setAttribute('aria-controls',desktopPanel.id);positionPanel();}else{if(desktopPanel.matches(':popover-open'))desktopPanel.hidePopover();if(!mobilePanel.open)mobilePanel.showModal();trigger.setAttribute('aria-controls',mobilePanel.id);}trigger.setAttribute('aria-expanded','true');};
    const queueClose=()=>{clearTimeout(closeTimer);closeTimer=setTimeout(()=>{if(!pinned&&!desktopPanel.contains(document.activeElement))closeTimeline();},180);};
    trigger.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&desktopMode())openTimeline();});
    trigger.addEventListener('pointerleave',()=>{if(desktopMode())queueClose();});
    desktopPanel.addEventListener('pointerenter',()=>clearTimeout(closeTimer));
    desktopPanel.addEventListener('pointerleave',queueClose);
    trigger.addEventListener('click',()=>{if(mobilePanel.open||pinned){closeTimeline(true);return;}pinned=true;openTimeline();});
    this.querySelectorAll('[data-timeline-close]').forEach(button=>button.addEventListener('click',()=>closeTimeline(true)));
    mobilePanel.addEventListener('cancel',event=>{event.preventDefault();closeTimeline(true);});
    mobilePanel.addEventListener('close',()=>trigger.setAttribute('aria-expanded','false'));
    mobilePanel.addEventListener('click',event=>{if(event.target===mobilePanel){const rect=mobilePanel.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeTimeline(true);}});
    document.addEventListener('pointerdown',event=>{if(desktopPanel.matches(':popover-open')&&!desktopPanel.contains(event.target)&&!trigger.contains(event.target))closeTimeline();},{signal:timelineEvents.signal});
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&desktopPanel.matches(':popover-open')){event.preventDefault();closeTimeline(true);}},{signal:timelineEvents.signal});
    desktopPanel.addEventListener('focusout',event=>{if(!desktopPanel.contains(event.relatedTarget)&&event.relatedTarget!==trigger)closeTimeline();});
    window.addEventListener('resize',()=>closeTimeline(),{signal:timelineEvents.signal});
    window.addEventListener('scroll',()=>{if(desktopPanel.matches(':popover-open'))closeTimeline();},{signal:timelineEvents.signal,passive:true});
    this.closeTimeline=closeTimeline;

    const form=this.querySelector('.mm-form'),name=form.querySelector('[required]'),signature=form.querySelector('input:not([required])'),error=this.querySelector('.mm-error'),result=this.querySelector('.mm-result');
    const review=event=>{
      event.preventDefault();result.hidden=true;
      if(!name.value.trim()){error.textContent=this.dataset.nameError;error.hidden=false;name.setAttribute('aria-invalid','true');name.focus();return;}
      error.hidden=true;name.removeAttribute('aria-invalid');
      if(document.querySelector('mm-master-cart')){closeTimeline();document.dispatchEvent(new CustomEvent('mm:master-add',{detail:{name:name.value.trim(),signature:signature.value.trim(),trigger:this.querySelector('.mm-add')}}));result.hidden=true;}else{result.hidden=false;result.textContent=this.dataset.previewMessage;}
      result.dataset.signaturePresent=String(Boolean(signature.value.trim()));
    };
    form.addEventListener('submit',review);this.querySelector('.mm-add').addEventListener('click',review);
    form.addEventListener('keydown',event=>{if(event.key==='Enter')review(event);});
    form.querySelectorAll('input').forEach(input=>input.addEventListener('input',()=>{result.hidden=true;if(name.value.trim()){error.hidden=true;name.removeAttribute('aria-invalid');}}));
    this.querySelectorAll('[data-personalize]').forEach(button=>button.addEventListener('click',()=>{form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});name.focus({preventScroll:true});}));

  }
  disconnectedCallback(){if(this.closeTimeline)this.closeTimeline();if(this.timelineEvents)this.timelineEvents.abort();delete this.dataset.initialized;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-xmas26-blanket"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mm-blanket-product')){customElements.define('mm-blanket-product',class extends HTMLElement{
  connectedCallback(){
    if(this.dataset.initialized)return;this.dataset.initialized='true';
    const main=this.querySelector('.mm-main-image');
    this.querySelectorAll('[data-photo]').forEach(button=>button.addEventListener('click',()=>{
      this.querySelectorAll('[data-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      main.src=button.dataset.photo;main.removeAttribute('srcset');main.alt=button.dataset.label;
    }));
    const parts=this.dataset.orderDate.split('-').map(Number),today=Date.UTC(parts[0],parts[1]-1,parts[2]);
    const dateFormat=new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',timeZone:'UTC'});
    const dateAt=offset=>new Date(today+offset*86400000),formatDate=value=>dateFormat.format(value);
    const arrivalWindow=[7,10].map(offset=>formatDate(dateAt(offset))).join(' - ');
    const trigger=this.querySelector('[data-delivery-window]'),desktopPanel=this.querySelector('.mm-timeline-desktop'),mobilePanel=this.querySelector('.mm-timeline-mobile');
    trigger.textContent=arrivalWindow;
    this.querySelectorAll('[data-order-day]').forEach(node=>{node.textContent=formatDate(dateAt(0));});
    this.querySelectorAll('[data-ship-window]').forEach(node=>{node.textContent=formatDate(dateAt(2));});
    this.querySelectorAll('[data-arrival-window]').forEach(node=>{node.textContent=arrivalWindow;});
    const timelineEvents=new AbortController();this.timelineEvents=timelineEvents;
    const desktopMode=()=>matchMedia('(min-width:750px) and (hover:hover)').matches;
    let pinned=false,closeTimer;
    const positionPanel=()=>{const anchor=trigger.getBoundingClientRect(),width=desktopPanel.offsetWidth,height=desktopPanel.offsetHeight,left=Math.max(12,Math.min(innerWidth-width-12,anchor.left+anchor.width/2-width/2)),above=anchor.bottom+height+12>innerHeight&&anchor.top>height+12;desktopPanel.style.left=left+'px';desktopPanel.style.top=(above?anchor.top-height-10:anchor.bottom+10)+'px';desktopPanel.style.setProperty('--mm-tip',Math.max(16,Math.min(width-16,anchor.left+anchor.width/2-left))+'px');desktopPanel.classList.toggle('mm-timeline-above',above);};
    const closeTimeline=(restore=false)=>{clearTimeout(closeTimer);if(desktopPanel.matches(':popover-open'))desktopPanel.hidePopover();if(mobilePanel.open)mobilePanel.close();trigger.setAttribute('aria-expanded','false');pinned=false;if(restore)trigger.focus({preventScroll:true});};
    const openTimeline=()=>{clearTimeout(closeTimer);if(desktopMode()){if(mobilePanel.open)mobilePanel.close();if(!desktopPanel.matches(':popover-open'))desktopPanel.showPopover({source:trigger});trigger.setAttribute('aria-controls',desktopPanel.id);positionPanel();}else{if(desktopPanel.matches(':popover-open'))desktopPanel.hidePopover();if(!mobilePanel.open)mobilePanel.showModal();trigger.setAttribute('aria-controls',mobilePanel.id);}trigger.setAttribute('aria-expanded','true');};
    const queueClose=()=>{clearTimeout(closeTimer);closeTimer=setTimeout(()=>{if(!pinned&&!desktopPanel.contains(document.activeElement))closeTimeline();},180);};
    trigger.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&desktopMode())openTimeline();});
    trigger.addEventListener('pointerleave',()=>{if(desktopMode())queueClose();});
    desktopPanel.addEventListener('pointerenter',()=>clearTimeout(closeTimer));
    desktopPanel.addEventListener('pointerleave',queueClose);
    trigger.addEventListener('click',()=>{if(mobilePanel.open||pinned){closeTimeline(true);return;}pinned=true;openTimeline();});
    this.querySelectorAll('[data-timeline-close]').forEach(button=>button.addEventListener('click',()=>closeTimeline(true)));
    mobilePanel.addEventListener('cancel',event=>{event.preventDefault();closeTimeline(true);});
    mobilePanel.addEventListener('close',()=>trigger.setAttribute('aria-expanded','false'));
    mobilePanel.addEventListener('click',event=>{if(event.target===mobilePanel){const rect=mobilePanel.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeTimeline(true);}});
    document.addEventListener('pointerdown',event=>{if(desktopPanel.matches(':popover-open')&&!desktopPanel.contains(event.target)&&!trigger.contains(event.target))closeTimeline();},{signal:timelineEvents.signal});
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&desktopPanel.matches(':popover-open')){event.preventDefault();closeTimeline(true);}},{signal:timelineEvents.signal});
    desktopPanel.addEventListener('focusout',event=>{if(!desktopPanel.contains(event.relatedTarget)&&event.relatedTarget!==trigger)closeTimeline();});
    window.addEventListener('resize',()=>closeTimeline(),{signal:timelineEvents.signal});
    window.addEventListener('scroll',()=>{if(desktopPanel.matches(':popover-open'))closeTimeline();},{signal:timelineEvents.signal,passive:true});
    this.closeTimeline=closeTimeline;

    const form=this.querySelector('.mm-form'),name=form.querySelector('[required]'),signature=form.querySelector('[name="properties[Your signature]"]'),error=this.querySelector('.mm-error'),result=this.querySelector('.mm-result'),add=this.querySelector('.mm-add');
    const review=async event=>{
      event.preventDefault();result.hidden=true;
      if(!name.value.trim()){error.textContent=this.dataset.nameError;error.hidden=false;name.setAttribute('aria-invalid','true');name.focus();return;}
      error.hidden=true;name.removeAttribute('aria-invalid');
      if(add.disabled)return;
      const id=form.elements.namedItem('id').value,properties={"Child's name":name.value.trim()};
      if(signature.value.trim())properties['Your signature']=signature.value.trim();
      const drawer=document.querySelector('mm-master-cart');
      add.disabled=true;add.setAttribute('aria-busy','true');
      try{if(!drawer)throw new Error(this.dataset.cartError);closeTimeline();await drawer.add({id,quantity:1,properties},add);}
      catch(issue){error.textContent=issue.message||this.dataset.cartError;error.hidden=false;}
      finally{add.disabled=false;add.removeAttribute('aria-busy');}
    };
    form.addEventListener('submit',review);
    form.querySelectorAll('input').forEach(input=>input.addEventListener('input',()=>{result.hidden=true;if(name.value.trim()){error.hidden=true;name.removeAttribute('aria-invalid');}}));
    this.querySelectorAll('[data-personalize]').forEach(button=>button.addEventListener('click',()=>{form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});name.focus({preventScroll:true});}));

  }
  disconnectedCallback(){if(this.closeTimeline)this.closeTimeline();if(this.timelineEvents)this.timelineEvents.abort();delete this.dataset.initialized;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-xmas26-cart-drawer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mm-master-cart')){customElements.define('mm-master-cart',class extends HTMLElement{
  connectedCallback(){
    if(this.events)return;this.events=new AbortController();const signal=this.events.signal;
    this.dialog=this.querySelector('dialog');this.list=this.querySelector('[data-cart-items]');this.lineTemplate=this.querySelector('template');this.status=this.querySelector('[data-cart-status]');this.cart={items:[],item_count:0,total_price:0,currency:'USD'};this.queue=Promise.resolve();
    document.addEventListener('click',event=>{const opener=event.target.closest('.mm-site-cart');if(opener){event.preventDefault();this.open(opener);this.refresh().catch(()=>this.announce(this.dataset.requestError));}},{signal});
    this.querySelectorAll('[data-cart-close]').forEach(button=>button.addEventListener('click',()=>this.close(),{signal}));
    this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.close();},{signal});
    this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.close();}},{signal});
    this.list.addEventListener('click',event=>{const control=event.target.closest('[data-cart-action]');if(!control)return;const key=control.closest('[data-line-id]').dataset.lineId,item=this.cart.items.find(entry=>entry.key===key);if(!item)return;const action=control.dataset.cartAction;this.changeQuantity(key,action==='remove'?0:item.quantity+(action==='increase'?1:-1));},{signal});
    this.list.addEventListener('change',event=>{if(!event.target.matches('[data-cart-quantity]'))return;const key=event.target.closest('[data-line-id]').dataset.lineId,quantity=Number(event.target.value);if(!Number.isSafeInteger(quantity)||quantity<1){this.render();this.announce(this.dataset.quantityError);return;}this.changeQuantity(key,quantity);},{signal});
    this.render();this.refresh().catch(()=>this.announce(this.dataset.requestError));
    window.addEventListener('pageshow',()=>this.refresh().catch(()=>this.announce(this.dataset.requestError)),{signal});
  }
  async request(endpoint,body){
    const options={credentials:'same-origin',headers:{Accept:'application/json'}};
    if(body){options.method='POST';options.headers['Content-Type']='application/json';options.body=JSON.stringify(body);}
    const response=await fetch(this.dataset.cartRoot+endpoint,options),data=await response.json();
    if(!response.ok)throw new Error(typeof data.description==='string'?data.description:this.dataset.requestError);
    return data;
  }
  enqueue(operation){const task=this.queue.then(async()=>{this.setBusy(true);try{return await operation();}finally{this.setBusy(false);}});this.queue=task.catch(()=>{});return task;}
  setBusy(value){this.busy=value;this.dialog.setAttribute('aria-busy',String(value));this.list.querySelectorAll('button,input').forEach(control=>{control.disabled=value||control.dataset.cartAction==='decrease'&&Number(control.closest('[data-line-id]').querySelector('[data-cart-quantity]').value)<=1;});this.querySelector('.mm-cart-checkout').disabled=value;}
  refresh(){return this.enqueue(async()=>{this.cart=await this.request('cart.js');this.render();return this.cart;});}
  add(item,trigger){return this.enqueue(async()=>{await this.request('cart/add.js',{items:[item]});this.cart=await this.request('cart.js');this.render();this.open(trigger);this.announce(this.dataset.addedMessage);});}
  changeQuantity(key,quantity){
    if(!Number.isSafeInteger(quantity)||quantity<0){this.render();this.announce(this.dataset.quantityError);return;}
    this.enqueue(async()=>{this.cart=await this.request('cart/change.js',{id:key,quantity});this.render();this.announce(quantity===0?this.dataset.removedMessage:this.dataset.updatedMessage);}).catch(issue=>{this.render();this.announce(issue.message||this.dataset.requestError);});
  }
  render(){
    const expanded=new Set(Array.from(this.list.querySelectorAll('details[open]')).map(node=>node.closest('[data-line-id]').dataset.lineId)),fragment=document.createDocumentFragment(),money=new Intl.NumberFormat('en-US',{style:'currency',currency:this.cart.currency||'USD'});
    this.cart.items.forEach((item,index)=>{
      const node=this.lineTemplate.content.cloneNode(true),line=node.querySelector('article');line.dataset.lineId=item.key;
      node.querySelectorAll('[data-line-link]').forEach(link=>{link.href=item.url;});node.querySelector('[data-line-title]').textContent=item.product_title;
      const image=node.querySelector('[data-line-image]');if(item.featured_image?.url||item.image){image.src=item.featured_image?.url||item.image;image.alt=item.featured_image?.alt||item.product_title;}else image.hidden=true;
      const variant=node.querySelector('[data-line-variant]');variant.textContent=item.variant_title==='Default Title'?'':item.variant_title;variant.hidden=!variant.textContent;
      const properties=Object.entries(item.properties||{}).filter(([key,value])=>!key.startsWith('_')&&value!==null&&String(value).trim());
      const dl=node.querySelector('[data-line-properties]');properties.forEach(([key,value])=>{const group=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=key;dd.textContent=String(value);group.append(dt,dd);dl.append(group);});
      node.querySelector('[data-property-count]').textContent='('+properties.length+')';const details=node.querySelector('details');details.hidden=!properties.length;details.open=expanded.has(item.key);
      const input=node.querySelector('[data-cart-quantity]');input.id='MMCartQty-'+this.id+'-'+index;input.value=String(item.quantity);node.querySelector('[data-cart-quantity-label]').htmlFor=input.id;
      node.querySelector('[data-cart-line-price]').textContent=money.format(item.final_line_price/100);fragment.append(node);
    });
    this.list.replaceChildren(fragment);const count=this.cart.item_count;
    this.querySelector('[data-cart-count]').textContent=String(count);this.querySelector('[data-cart-subtotal]').textContent=money.format(this.cart.total_price/100);
    this.querySelector('[data-cart-empty]').hidden=count>0;this.querySelector('[data-cart-footer]').hidden=!count;this.querySelector('[data-cart-review]').hidden=!count;
    this.querySelector('[data-cart-shipping]').hidden=!count||!this.cart.items.every(item=>item.product_type==='Personalized Hooded Blanket');
    document.querySelectorAll('.mm-site-cart').forEach(link=>{let badge=link.querySelector('.mm-site-cart-count');if(!badge){badge=document.createElement('span');badge.className='mm-site-cart-count';link.append(badge);}badge.textContent=String(count);badge.hidden=!count;link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls',this.dialog.id);});
  }
  announce(message){this.status.textContent='';requestAnimationFrame(()=>{this.status.textContent=message;});}
  open(trigger){this.returnFocus=trigger instanceof HTMLElement?trigger:document.activeElement;if(!this.dialog.open)this.dialog.showModal();}
  close(){if(this.dialog.open)this.dialog.close();if(this.returnFocus?.isConnected)this.returnFocus.focus({preventScroll:true});}
  disconnectedCallback(){this.close();this.events?.abort();this.events=null;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-xmas26-store-header"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mm-store-header')){customElements.define('mm-store-header',class extends HTMLElement{
  connectedCallback(){
    if(this.events)return;this.events=new AbortController();const signal=this.events.signal;
    this.querySelectorAll('details').forEach(details=>details.addEventListener('toggle',()=>{if(details.open)this.querySelectorAll('details').forEach(other=>{if(other!==details)other.open=false;});},{signal}));
    this.addEventListener('click',event=>{if(event.target.closest('a'))this.querySelectorAll('details').forEach(details=>{details.open=false;});},{signal});
    document.addEventListener('pointerdown',event=>{if(!this.contains(event.target))this.querySelectorAll('details').forEach(details=>{details.open=false;});},{signal});
    this.addEventListener('keydown',event=>{if(event.key==='Escape'){const current=event.target.closest('details[open]');if(current){current.open=false;current.querySelector('summary').focus();}}},{signal});
  }
  disconnectedCallback(){if(this.events)this.events.abort();this.events=null;}
});}

  } catch(e) { console.error(e); }
})();
})();
